export const routesWithoutSideMenu: string[] = ['/login']
